import { addTask, updateTask, removeTask, listTask, copyTask } from '@/api/task/task'

const state = {
  checkTaskInfo: {},
  taskList: [],
  taskTotal: 0,
  showTaskEdit: false,
  showTaskAdd: false,
  currentStepForm: {},
  currentStepList: [],
  currentTrigger: {},
  showTaskSort: false,
  cardType: 0,  //0卡片模式  1列表模式
  resourceCardType: 1,  // 资源库列表 0卡片模式  1列表模式
  courseListPage: {  //存储分页页数，为了实现返回页面定位到具体页面记录
    page: 1,
    itemsPerPage: 8
  },
  thirdPartySoftListPage: {  //存储分页页数，为了实现返回页面定位到具体页面记录
    page: 1,
    itemsPerPage: 8
  },
  taskCurrentPage: 1, //当前页数
}

const actions = {
  async copyTask({ commit, state }, task) {
    const res = await copyTask({
      _id: task._id
    })
    if (res.code == 200) {
      const list = [].concat(state.taskList);
      list.push(res.data)
      commit('SET_TASK_LIST', list);
      this.dispatch('global/showSuccessMsg', '操作成功')
    }
  },
  async updateStepItem({ commit, state }, form) {
    const stepList = state.currentStepList;
    const index = stepList.findIndex(step => step.id === form.id)
    commit('SET_STEP_ITEM', { form, index })
  },
  async setStepForm({ commit }, form) {
    commit('SET_STEP_FORM', form);
  },
  async setStepList({ commit }, list) {
    commit('SET_STEP_LIST', list);
  },
  async setTigger({ commit }, tirgger) {
    commit('SET_TRIGGER', tirgger);
  },
  async setTaskEditor({ commit, state }, taskSceneId) {
    const data = Object.assign({}, state.checkTaskInfo)
    data['taskEditor'] = taskSceneId
    commit('SET_TASK_INFO', data)
  },
  async setTaskInfo({ commit }, task) {
    commit('SET_TASK_INFO', task)
  },
  async saveTask({ dispatch }, task) {
    let data = Object.assign({}, task);
    const project = this.state.courseAndProject.project;
    const course = this.state.courseAndProject.course;
    if (task._id === undefined) {
      data.project = project._id;
    }
    data.course = course._id
    const handleFunc = task._id ? updateTask : addTask
    if (!task._id) {
      data = Object.assign(
        {
          flowJsonData: {},
          flowMapData: {},
          flowTriggerMap: {},
          subTaskGraph: {},
          subTaskList: []
        },
        data
      )
    };
    let res = await handleFunc(data);
    this.dispatch('global/showSuccessMsg', '操作成功'); 
    dispatch('refreshTaskList', {});
    dispatch('reverseShowTaskEdit', false);
    dispatch('reverseShowTaskAdd', false);
    return res;
  },
  noNest({ dispatch }, task) {
    this.dispatch('global/showWarningMsg', '动作节点不允许嵌套!');
  },
  async removeTask({ dispatch }, task) {
    await removeTask(task);
    this.dispatch('global/showSuccessMsg', '删除成功');
  },
  async reverseShowTaskEdit({ commit }, status) {
    commit('REVERSE_SHOW_TASK_EDIT', status)
  },
  async reverseShowTaskAdd({ commit }, status) {
    commit('REVERSE_SHOW_TASK_ADD', status)
  },
  async setTaskCurrentPage({ commit }, currentPage) {
    commit('SET_TASK_CURRENT_PAGE', currentPage)
  },
  async refreshTaskList({ commit, state }, data = {}) {
    commit('SET_TASK_LIST', [])
    const project = this.state.courseAndProject.project;
    if (!project._id) {
      return;
    }
    let params = {
      project: project._id,
      currentPage: state.taskCurrentPage||1,
      perPage: 5,
      name: ''
    }
    if (JSON.stringify(data) !== "{}") {
      params.currentPage = data.currentPage;
      params.perPage = data.perPage;
      params.name = data.queryName;
    }

    const taskListRes = await listTask(params)
    if (taskListRes.code == 200) {
      commit('SET_TASK_TOTAL', taskListRes.data.total)
      commit('SET_TASK_LIST', taskListRes.data.rows)
    }
  }
}

const mutations = {
  SET_TASK_SORT_DIALOG(state, status) {
    state.showTaskSort = status ?? false;
  },
  SET_STEP_ITEM(state, { form, index }) {
    state.currentStepList[index] = form;
  },
  SET_TASK_INFO(state, task) {
    state.checkTaskInfo = task
  },
  PUSH_TASK_LIST(state, task) {
    state.taskList.push(task)
  },
  SET_TASK_LIST(state, taskList) {
    state.taskList = taskList
  },
  SET_TASK_TOTAL(state, total) {
    state.taskTotal = total
  },
  SET_STEP_FORM(state, form) {
    state.currentStepForm = Object.assign({}, form);
  },
  SET_STEP_LIST(state, list) {
    state.currentStepList = list;
  },
  SET_TRIGGER(state, trigger) {
    state.currentTrigger = Object.assign({}, trigger);
  },
  REVERSE_SHOW_TASK_EDIT(state, status) {
    state.showTaskEdit = status
  },
  REVERSE_SHOW_TASK_ADD(state, status) {
    state.showTaskAdd = status
  },
  SET_TASK_CURRENT_PAGE(state, currentPage) {
    state.taskCurrentPage = currentPage
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
